export default __webpack_public_path__ + "static/media/plus.59ec0158.svg";